import constants from 'constants/index'

const isSupplier = (company) =>
  company?.kind === constants.companies.KINDS.SUPPLIER

export default isSupplier
